import signsofburnout from "../img/signsofburnout.png";
import alreadyburntout from "../img/alreadyburntout.jpeg";


const blogs = [
    {
        id: 1,
        title: "Burnout in Tech and How to deal with them",
        image1: signsofburnout,
        image2: alreadyburntout,
        date: "26",
        month: "oct",
        link: "https://blog.decagonhq.com/burnout-in-software-engineering-and-how-to-deal-with-it/"
    },
];

export default blogs;